import { fileServerAddr } from "../networkConfig";

export default {
	csvFileUpload(formData) {
		return fileServerAddr.post("/company/setup/upload/", formData, {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		});
	},
	staffCsvFileUpload(formData) {
		return fileServerAddr.post("/upload/employee-csv/", formData, {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		});
	},
	uploadPreparationMethod(product_id, formData) {
		console.log(product_id, formData);
		return fileServerAddr.patch(`/product/${product_id}/upload/`, formData, {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		});
	}

	// csvFileUpload(formData) {
	// 	return fileServerAddr.post("/upload/employee-csv/", formData, {
	// 		headers: {
	// 			"Content-Type": "multipart/form-data"
	// 		}
	// 	});
	// }
};
